// Hasura primary read window used for read-after-write scenarios:

// Hasura read queries are normally routed to the (read-only) replica service. This
// service is backed by the Aurora reader endpoint, which lags the writer by a
// short interval, so a read issued immediately after a write can return stale data.

// To avoid that, any mutation opens a short "prefer primary" window: for
// 5 seconds after a write, reads are routed back to the primary (writer)
// Hasura service. This keeps post-mutation refetches (e.g. `resetStore()`)
// consistent, then reads revert to the replica once the window elapses.
// The window should comfortably exceed real replication lag.

// NOTE: this window applies to Hasura HTTP queries only. Subscriptions are
// intentionally NOT window-aware — they always read the replica (see
// hasuraClient.ts). Hasura subscriptions are polling live queries (~1s), so a
// subscription-backed view opened right after a write can render briefly stale,
// then self-corrects within ~1s + replication lag. This is a deliberate trade-off.

// Aurora replication lag is typically sub-second; 5s is a generous safety margin.
const HASURA_PRIMARY_READ_WINDOW_MS = 5000;

let hasuraPrimaryReadsUntil = 0;

// Call when a write (mutation) completes; opens the "prefer primary" window
export function markWrite() {
  hasuraPrimaryReadsUntil = Date.now() + HASURA_PRIMARY_READ_WINDOW_MS;
}

export function shouldReadFromHasuraPrimary(): boolean {
  return Date.now() < hasuraPrimaryReadsUntil;
}
